import { render, staticRenderFns } from "./CustomerRanking.vue?vue&type=template&id=6daeef32&scoped=true&"
import script from "./CustomerRanking.vue?vue&type=script&lang=js&"
export * from "./CustomerRanking.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRanking.vue?vue&type=style&index=0&id=6daeef32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daeef32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VProgressLinear,VSelect,VSimpleTable})
